/**
 * `/` — auth-aware entry point.
 *
 *   - unauthenticated  → /login
 *   - authenticated    → /boards (default) or /dashboard when the
 *                         founder has opted into "Use dashboard as
 *                         landing" via Settings → Profile (Phase 12).
 *
 * Founder mandate (2026-05-15): post-login lands on actual content,
 * never a marketing screen. The landing preference is per-device in
 * localStorage — no migration needed, no DB write on every signin.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { useAuthStore } from '../stores/auth-store';

const LANDING_KEY = 'chaos-landing-preference';

function preferredLanding(): '/boards' | '/dashboard' {
  try {
    const raw = typeof localStorage !== 'undefined' ? localStorage.getItem(LANDING_KEY) : null;
    if (raw === 'dashboard') return '/dashboard';
  } catch {
    /* ignore */
  }
  return '/boards';
}

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const state = useAuthStore.getState();
    if (state.status === 'authenticated') {
      throw redirect({ to: preferredLanding() });
    }
    throw redirect({ to: '/login' });
  },
});

export const __testing = { LANDING_KEY };
